<app-main-header></app-main-header>
<mat-sidenav-container class="sidenav__container" id="side">
  <router-outlet></router-outlet>
</mat-sidenav-container>
